import React, { useState, useEffect, useContext } from "react";
import { translate } from "utils/Translate";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI } from "utils/API";
import ProductNormal from "components/elements/ProductNormal";
import { setupProductImages } from "utils/productImageHelper";
import CircularIndeterminate from "components/blocks/progressBar/progressBar";
import { Box } from "@mui/material";
import ContentNormal from "components/elements/ContentNormal";
import Headline5 from "components/elements/Headline5";
import FileSaver from "file-saver";
import { AppContext } from "contexts/AppContext";
import ButtonMedium4 from "components/elements/ButtonMedium4";

const Wishlist = () => {
  const { brandData } = useContext(AppContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pdfExportLoading, setPdfExportLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [productPackages, setProductPackages] = useState([]);

  const fetchWishlist = async () => {
    await fetchWishlistProducts()
    await fetchWishlistProductPackages()
    setLoading(false)
  }

  const fetchWishlistProducts = async () => {
    const shopproducts = await callAPI(`product/wishlist`, "GET")
    if(shopproducts?.length) {
      shopproducts.forEach(product => {
        setupProductImages(product, false)
      })
      setProducts(shopproducts)
    }
  }

  const fetchWishlistProductPackages = async () => {
    const wishlistProductPackages = await callAPI(`productPackages/wishlist`, "GET")
    if(wishlistProductPackages?.length) {
      wishlistProductPackages.forEach(product => {
        setupProductImages(product, false)
      })
      setProductPackages(wishlistProductPackages)
    }
  }

  const onExportToPdfClick = async () => {
    setPdfExportLoading(true)
    try {
      const pdfBase64 = await callAPI(`product/exportWishlist`, "GET", { query: { showRetailPrice: !!brandData?.features?.exportWishlistShowRetailPrice } })
      const byteCharacters = atob(pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
  
      FileSaver.saveAs(blob, `${brandData.brandSlug}_wishlist.pdf`);
    } catch (err) {
      
    }
    setPdfExportLoading(false)
  }

  useEffect(() => {
    fetchWishlist()
  }, [])

  return (
    <Box flex={1} display={'flex'} flexDirection={'column'} gap={4}>
      {loading
        ?
        <Box marginTop={4} display={'flex'} flex={1} justifyContent={'center'} >
          <CircularIndeterminate />
        </Box>
        :
        products?.length <= 0 && productPackages?.length <= 0
          ?
          <Box display={'flex'} flexDirection={'column'} alignItems={'center'} marginTop={4}>
            <Headline5
              translationKey='_NO_PRODUCTS_'
              fallbackText='Ingen produkter'
              style={{textAlign: 'center'}}
            />
            <ContentNormal
              translationKey='_EMPTY_WISHLIST_'
              fallbackText='Du har ingen produkter på ønskelisten'
              style={{textAlign: 'center'}}
            />
          </Box>
          :
          <Box display={'flex'} flexDirection={'column'} gap={3}>
            {!!brandData?.features?.showExportWishlistButton &&
              <Box display={'flex'} justifyContent={'start'}>
                <ButtonMedium4
                  showIcon={false}
                  translationKey={"_EXPORT_TO_PDF_"}
                  fallbackText={"Eksportér til PDF"}
                  onClick={onExportToPdfClick}
                  loading={pdfExportLoading}
                />
              </Box>
            }
            <Box display={'flex'} columnGap={{xs: 1, md: 6}} rowGap={6} flexWrap={'wrap'} justifyContent={{xs: 'flex-start', md: undefined}}>
              {products.map((item) => (
                <ProductNormal
                  key={item.ProductID}
                  ProductID={item.ProductID}
                  ShopID={item.ShopID}
                  showTag={item.enableDiscount ? true : false}
                  tagOptions={{
                    fallbackText: `${translate("_PRODUCT_DISCOUNT_TAG_TEXT_", "Spar")} ${Math.round((item.sellingPrice.nonDiscountAmount - item.sellingPrice.amount) / item.sellingPrice.nonDiscountAmount * 100)}%`,
                    showClose: false,
                  }}
                  tagStyles={{ borderRadius: 8 }}
                  price={item.sellingPrice}
                  productReaction={item.reaction}
                  style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
                  text2={item.elementTitle}
                  text1={item.manufacturer}
                  imageSrc={`url(${item.images[0].imageOriginSource})`}
                  imageBackgroundColor={item.imageBackgroundColor}
                  activityName='profile'
                />
              ))}
              {productPackages.map((item) => (
                <ProductNormal
                  key={item.ProductPackageID}
                  ProductPackageID={item.ProductPackageID}
                  ShopID={item.ShopID}
                  showTag={item.enableDiscount ? true : false}
                  tagOptions={{
                    fallbackText: `${translate("_PRODUCT_DISCOUNT_TAG_TEXT_", "Spar")} ${Math.round((item.sellingPrice.nonDiscountAmount - item.sellingPrice.amount) / item.sellingPrice.nonDiscountAmount * 100)}%`,
                    showClose: false,
                  }}
                  tagStyles={{ borderRadius: 8 }}
                  price={item.sellingPrice}
                  productReaction={item.reaction}
                  style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
                  text1={item.manufacturer}
                  text2={item.title}
                  imageSrc={`url(${item.images[0].imageOriginSource})`}
                  imageBackgroundColor={item.imageBackgroundColor}
                  activityName='profile'
                />
              ))}
            </Box>
          </Box>
      }
      <Box display={'flex'} justifyContent={'center'} >
        <ButtonMedium4
          showIcon={false}
          translationKey="_PROFILE_PAGE_SEE_ALL_PRODUCTS_"
          fallbackText="Se alle produkter"
          onClick={() => navigate(`/shop`)}
        />
      </Box>
    </Box>
  )
}

export default Wishlist;
